import { createContext, ReactNode } from 'react';

// project import
import defaultConfig from 'config';
import useLocalStorage from 'hooks/useLocalStorage';

// types
import { CustomizationProps, FontFamily, I18n, PresetColor, ThemeDirection, ThemeMode } from 'types/config';

// initial state
const initialState: CustomizationProps = {
  ...defaultConfig,
  onChangeContainer: () => {},
  onChangeMode: (mode: ThemeMode) => {},
  onChangePresetColor: (theme: PresetColor) => {},
  onChangeDirection: (direction: ThemeDirection) => {},
  onChangeMiniDrawer: (miniDrawer: boolean) => {},
  onChangeFontFamily: (fontFamily: FontFamily) => {},
  onChangeLocale: (i18n: I18n) => {}
};

// ==============================|| CONFIG CONTEXT & PROVIDER ||============================== //

const ConfigContext = createContext(initialState);

type ConfigProviderProps = {
  children: ReactNode;
};

function ConfigProvider({ children }: ConfigProviderProps) {
  const [config, setConfig] = useLocalStorage('mantis-react-next-ts-config', initialState);

  const onChangeContainer = () => {
    setConfig((prev) => ({ ...prev, container: !prev.container }));
  };

  const onChangeMode = (mode: ThemeMode) => {
    setConfig((prev) => ({ ...prev, mode }));
  };

  const onChangePresetColor = (theme: PresetColor) => {
    setConfig((prev) => ({ ...prev, presetColor: theme }));
  };

  const onChangeDirection = (direction: ThemeDirection) => {
    setConfig((prev) => ({ ...prev, themeDirection: direction }));
  };

  const onChangeMiniDrawer = (miniDrawer: boolean) => {
    setConfig((prev) => ({ ...prev, miniDrawer }));
  };

  const onChangeFontFamily = (fontFamily: FontFamily) => {
    setConfig((prev) => ({ ...prev, fontFamily }));
  };

  const onChangeLocale = (i18n: I18n) => {
    setConfig((prev) => {
      return { ...prev, i18n };
    });
  };

  return (
    <ConfigContext.Provider
      value={{
        ...config,
        onChangeContainer,
        onChangeMode,
        onChangePresetColor,
        onChangeDirection,
        onChangeMiniDrawer,
        onChangeFontFamily,
        onChangeLocale
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
}

export { ConfigProvider, ConfigContext };
